import { ActionCreator } from 'redux';
import { connect } from 'react-redux';

import { actions } from '../../../state/filterActions';
import { fetchResults } from '../../../state/resultActions';

import { OverrideValues, PaleState } from '../../../interfaces';
import { DistanceSliderDispatchProps, DistanceSlider, DistanceSliderStateProps } from './DistanceSlider';

export const mapStateToProps = ({ filters }: PaleState): DistanceSliderStateProps => ({
    id: 'DistanceToCityFilter',
    label: 'Avstand til sentrum',
    min: 0,
    max: 5000,
    initialDistance: filters.distanceToCity ? filters.distanceToCity[1] : undefined,
});

export const mapDispatchToProps: OverrideValues<DistanceSliderDispatchProps, ActionCreator<unknown>> = {
    distanceChange: actions.filterDistanceToCity,
    triggerFetch: fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(DistanceSlider);
